/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<Relations>, schemaOptions: { partial: true })
 */
export interface RelationsPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    userId?: number;
    relatedUserId?: number;
    relationTypeId?: string;
    /**
     * Relación Jefe de tipo staff/asistente: cuelga del jefe pero no al nivel de sus otros subordinados (organigrama de Consejo)
     */
    isStaff?: boolean;
    /**
     * Relación creada ad-hoc al agregar un evaluador custom a una evaluación: no forma parte del organigrama oficial y se excluye de los árboles de organigrama
     */
    isCustom?: boolean;
    /**
     * Fecha en que la relación se finalizó. Una relación finalizada conserva los resultados de sus encuestas pero sale del organigrama y de nuevas evaluaciones
     */
    endedOn?: string | null;
    /**
     * Usuario que finalizó la relación
     */
    endedBy?: number | null;
}

